var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.502,
    height: 73.803,
    viewBox: "0 0 61.502 73.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Melding",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(24.599 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M20.763,12.854a1.538,1.538,0,0,1-1.538-1.538V6.15a3.075,3.075,0,0,0-6.15,0v5.166a1.538,1.538,0,1,1-3.075,0V6.15a6.15,6.15,0,0,1,12.3,0v5.166A1.536,1.536,0,0,1,20.763,12.854Z",
    transform: "translate(-10 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(19.989 61.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M19.263,32.3A10.775,10.775,0,0,1,8.5,21.538a1.538,1.538,0,0,1,3.075,0,7.688,7.688,0,0,0,15.376,0,1.538,1.538,0,1,1,3.075,0A10.775,10.775,0,0,1,19.263,32.3Z",
    transform: "translate(-8.5 -20)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(0 9.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M58.89,58.352H6.613a4.613,4.613,0,0,1-3-8.118,21.379,21.379,0,0,0,7.611-16.366V24.526a21.526,21.526,0,0,1,43.052,0v9.342a21.355,21.355,0,0,0,7.586,16.344,4.613,4.613,0,0,1-2.974,8.14ZM32.751,6.075A18.469,18.469,0,0,0,14.3,24.526v9.342A24.43,24.43,0,0,1,5.626,52.562a1.537,1.537,0,0,0,.987,2.715H58.89a1.538,1.538,0,0,0,1-2.706,24.449,24.449,0,0,1-8.687-18.7V24.526A18.469,18.469,0,0,0,32.751,6.075Z",
    transform: "translate(-2 -3)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.235f8f83eb6652c4cd334647b2851ac9.svg";
export { ForwardRef as ReactComponent };